
























































































































































































































// import DataPresensi from "@/services/DataPresensi";
import { appModule } from "@/store/modules/app";
// import { storePresensi } from "@/store/modules/presensi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import UnitAllAutoComplete from "@/components/UnitAllAutoComplete.vue";
import DokterAutoComplete from "@/components/DokterAutoComplete.vue";
import DataBed from "@/services/DataBed";
import { storeBed } from "@/store/modules/bed";
import { userModule } from "@/store/modules/user";
import DataReferensi from "@/services/DataReferensi";
@Component({
  components: {
    UnitAllAutoComplete,
    DokterAutoComplete,
  },
})
export default class ModalAddPasien extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() item!: object;
  @Prop() unit!: object;
  // jam = "jam";
  // valid = [(v) => this.cek(v) || this.message()];
  valid = [(v) => !!v || "*Data harus diisi"];
  msg = "";
  diagnosa = null;
  rm = null;
  unitAll = {};
  dokter = {};
  catatanPasien = "";
  // reg = "";
  disRM = false;
  showBtnKey = false;
  showKey = false;
  key = "";

  get head() {
    const head = [
      {
        text: "NO",
        value: "nomor",
        width: "10vh",
        align: "center",
      },
      {
        text: "RM",
        value: "rm",
        width: "10vh",
        align: "left",
      },
      {
        text: "Identitas",
        value: "identitas",
        width: "25vh",
        align: "left",
      },
      {
        text: "Catatan Pemesanan",
        value: "catatan",
        align: "left",
      },
      {
        text: "Hapus",
        value: "hapus",
        width: "10vh",
        align: "center",
      },
    ];
    return head;
  }

  get dataPasien() {
    return storeBed.pasien;
  }

  get listBooking() {
    return storeBed.booking;
  }

  @Watch("dataPasien")
  getDataPasien(val) {
    this.unitAll = {};
    this.dokter = {};
    if (val && val.register) {
      this.dokter = {
        id: val.register.dr,
      };
    }
    this.unitAll = {
      id: val.register.unit,
    };
  }

  setUnitAll(val) {
    this.unitAll = val;
  }

  setDokter(val) {
    this.dokter = val;
  }

  simpan() {
    // if (this.dataPasien["register"]) {
    //   this.reg = this.dataPasien["register"].no;
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      if (this.dataPasien["register"]) {
        if (this.unitAll["id"] && this.dokter["id"]) {
          // appModule.sendErrorAlert("terisi");
          const dt = DataBed.postPasien(
            this.item["id"],
            this.rm,
            this.diagnosa,
            this.unitAll["id"],
            this.dokter["id"],
            this.dataPasien["register"].no,
            this.user["pegawai_id"],
            this.catatanPasien
          );
          dt.then((dt) => {
            if (dt["status"] != 1) {
              appModule.sendErrorAlert(dt["message"]);
            } else {
              appModule.NoticeDelay("Berhasil Menambahkan Pasien");
              this.close();
              storeBed.actBedByUnit(this.item["unit"].id);
            }
          });
        } else {
          appModule.sendErrorAlert("Pastikan Asal unit dan DPJP Terisi");
        }
      } else {
        appModule.sendErrorAlert(
          "Pastikan Tekan Enter setelah input No RM dan Ada No Register"
        );
        // }
      }
    }
  }

  hapus(val) {
    const dt = DataBed.deleteBooking(val.id, this.user["pegawai_id"]);
    dt.then((dt) => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        const param = {
          unitID: this.item["unit"].id,
          kelasID: this.item["kelas"].id,
        };
        appModule.NoticeDelay("Berhasil Hapus Pemesanan Kamar");
        storeBed.actBooking(param);
      }
    });
  }

  rmSubstr(val) {
    return val.substr(2, 6);
  }

  add(val) {
    console.log(val.substr(2, 6));
    this.rm = val.substr(2, 6);
    storeBed.actPasien(val.substr(2, 6));
    // const dt = DataBed.deleteBooking(val.id, this.user["pegawai_id"]);
    // dt.then((dt) => {
    //   if (dt["status"] != 1) {
    //     appModule.sendErrorAlert(dt["message"]);
    //   } else {
    //     const param = {
    //       unitID: this.item["unit"].id,
    //       kelasID: this.item["kelas"].id,
    //     };
    //     appModule.NoticeDelay("Berhasil Hapus Booking Kamar");
    //     storeBed.actBooking(param);
    //   }
    // });
  }
  dataPx(rm) {
    storeBed.actPasien(rm);
  }
  // setUnit(val) {
  //   this.unit = val;
  // }
  // setKelas(val) {
  //   this.kelas = val;
  // }

  close() {
    storeBed.actClearBooking();
    storeBed.actClearPasien();
    this.diagnosa = null;
    this.rm = null;
    this.show = false;
    this.unitAll = {};
    this.dokter = {};
    this.catatanPasien = "";
    this.disRM = false;
    this.showBtnKey = false;
    this.showKey = false;
    this.key = "";
  }

  message() {
    return this.msg;
  }

  get user() {
    return userModule.user;
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  @Watch("listBooking")
  disableRM(val) {
    if (val.length > 0) {
      this.disRM = true;
      this.showBtnKey = true;
    } else {
      this.disRM = false;
      this.showBtnKey = false;
    }
  }
  openKey() {
    this.showKey = true;
  }
  enterPass() {
    const dt = DataReferensi.postDataKey(this.key);
    dt.then((dt) => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        this.disRM = false;
        this.showKey = false;
        this.showBtnKey = false;
      }
    });

    // if (this.key == "manutmas") {
    //   this.disRM = false;
    //   this.showKey = false;
    //   this.showBtnKey = false;
    // } else {
    //   appModule.sendErrorAlert("Kode Salah");
    // }
  }
}
